import { useState } from "react";
import axios from "axios";
import { API } from "../config";

function ContactForm({ lang, t }) {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: "", message: "" });
    try {
      const response = await axios.post(`${API}/contact`, { ...formData, lang });
      setStatus({ type: "success", message: response.data.message });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      const errorMsg = error.response?.data?.detail ||
        (lang === "DE" ? "Fehler beim Senden. Bitte versuchen Sie es erneut." :
         lang === "EN" ? "Error sending message. Please try again." :
         "Erreur lors de l'envoi. Veuillez réessayer.");
      setStatus({ type: "error", message: errorMsg });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form" noValidate>
      <div className="form-group">
        <label htmlFor="name" className="form-label">{t.formName}</label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="form-input" placeholder={t.formNamePlaceholder} data-testid="form-name-input" autoComplete="name" aria-required="true" />
      </div>
      <div className="form-group">
        <label htmlFor="email" className="form-label">{t.formEmail}</label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="form-input" placeholder={t.formEmailPlaceholder} data-testid="form-email-input" autoComplete="email" aria-required="true" />
      </div>
      <div className="form-group">
        <label htmlFor="message" className="form-label">{t.formMessage}</label>
        <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows="4" className="form-input form-textarea" placeholder={t.formMessagePlaceholder} data-testid="form-message-input" aria-required="true" />
      </div>
      <div aria-live="polite" aria-atomic="true">
        {status.message && (
          <div className={`form-status ${status.type}`} data-testid="form-status" role={status.type === "error" ? "alert" : "status"}>
            {status.message}
          </div>
        )}
      </div>
      <button type="submit" className="btn-primary form-submit" disabled={isSubmitting} data-testid="form-submit-btn">
        {isSubmitting ? t.formSending : t.formSubmit}
      </button>
    </form>
  );
}

export default function ContactSection({ lang, t }) {
  return (
    <section id="kontakt" className="contact-section" data-testid="contact-section">
      <div className="section-inner">
        <div className="contact-grid">
          <div className="contact-text-col fade-in-left">
            <div className="section-label">{t.contactLabel}</div>
            <h2 className="section-title">{t.contactTitle}</h2>
            <p className="contact-desc">{t.contactText}</p>
            <ContactForm lang={lang} t={t} />
            <div className="whatsapp-divider">
              <span>{t.orWhatsapp}</span>
            </div>
            <a
              href="https://wa.me/491731064508?text=Hallo%20Dominik%2C%20ich%20interessiere%20mich%20für%20UNDRIVE"
              className="contact-btn whatsapp"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-btn"
              aria-label={lang === "DE" ? "WhatsApp Nachricht senden" : lang === "EN" ? "Send WhatsApp message" : "Envoyer un message WhatsApp"}
            >
              <span className="contact-icon" aria-hidden="true">💬</span>
              <span className="contact-btn-text">
                <span className="contact-btn-label">{t.whatsappLabel}</span>
                <span className="contact-btn-value">WhatsApp</span>
              </span>
            </a>
          </div>
          <div className="contact-info-col fade-in-right" style={{ transitionDelay: "0.15s" }}>
            <div className="info-card">
              <h3 className="info-title">{t.contactDetails}</h3>
              <div className="info-row">
                <span className="info-icon" aria-hidden="true">👤</span>
                <div>
                  <div className="info-label">Name</div>
                  <div className="info-value">Dominik Mietke</div>
                </div>
              </div>
              <div className="info-row">
                <span className="info-icon" aria-hidden="true">🏢</span>
                <div>
                  <div className="info-label">{lang === "DE" ? "Unternehmen" : lang === "EN" ? "Company" : "Société"}</div>
                  <div className="info-value">UNDRIVE</div>
                </div>
              </div>
              <div className="info-row">
                <span className="info-icon" aria-hidden="true">📱</span>
                <div>
                  <div className="info-label">{lang === "DE" ? "Telefon / WhatsApp" : lang === "EN" ? "Phone / WhatsApp" : "Téléphone / WhatsApp"}</div>
                  <div className="info-value"><a href="tel:+491731064508">0173 1064 508</a></div>
                </div>
              </div>
              <div className="info-row">
                <span className="info-icon" aria-hidden="true">✉️</span>
                <div>
                  <div className="info-label">E-Mail</div>
                  <div className="info-value"><a href="mailto:hallo@undrive.de">hallo@undrive.de</a></div>
                </div>
              </div>
              <div className="info-row">
                <span className="info-icon" aria-hidden="true">🌐</span>
                <div>
                  <div className="info-label">Website</div>
                  <div className="info-value"><a href="https://undrive.de" target="_blank" rel="noopener noreferrer">www.undrive.de</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
